import { store } from "../store";
import { api } from "../http";
import {DefaultRes, UserActivityTypes} from "../types";
import { AxiosError, AxiosResponse } from "axios";
import { RESPONSE_CODES } from "../constants/responseCodes.constants";

export class UserActivityService {
    public static readonly dispatch = store.dispatch.userActivity;
    public static readonly state = store.getState();

    public static async fetchUserActivityData(
        filter : UserActivityTypes.UserActivityFilter,
        sortBy: string,
        sortOrder: 'ASC' | 'DESC',
        callback?: (isValid?: boolean, message?: string) => void
    ): Promise<any | void> {
        const {
            dispatch: { toggleLoading, setActiveUserRecords },
        } = UserActivityService;

        toggleLoading("fetchActiveUserData", true);

        try {
            const {startDate, endDate, teamIds, groupId} = filter;
            const {
                data: { result, isValid, message },
            } = await api.post<
                DefaultRes<UserActivityTypes.ActiveUserData>,
                AxiosResponse<DefaultRes<UserActivityTypes.ActiveUserData>>
            >(`user-activity/getTeamActivity`, {
                startDate,
                endDate,
                sortBy,
                sortOrder,
                teamIds,
                ...(groupId != null ? { groupId } : {})
            });
            toggleLoading("fetchActiveUserData", false);

            if (isValid) {
                setActiveUserRecords(result);
            }

            callback && callback(isValid, RESPONSE_CODES[message]);
            return result;
        } catch (error: any) {
            toggleLoading("fetchActiveUserData", false);
            setActiveUserRecords([]);
            if (error.response) {
                const ERROR_CODE = (
                    error as AxiosError<DefaultRes>
                ).response?.data?.message;

                callback && callback(false, RESPONSE_CODES[ERROR_CODE!] || RESPONSE_CODES.UNKNOWN);
                return;
            }

            callback && callback(false, String(error));
        }
    }

    public static async fetchWeeklyActivityData(
        filter : UserActivityTypes.UserActivityFilter,
        sortBy: string,
        sortOrder: 'ASC' | 'DESC',
        callback?: (isValid?: boolean, message?: string) => void
    ): Promise<any | void> {
        const {
            dispatch: { toggleLoading, setWeeklyActiveUserRecords },
        } = UserActivityService;

        toggleLoading("fetchWeeklyActiveData", true);
        const {teamIds, groupId} = filter;
        try {
            const {
                data: { result, isValid, message },
            } = await api.post<
                DefaultRes<UserActivityTypes.WeeklyActivityData>,
                AxiosResponse<DefaultRes<UserActivityTypes.WeeklyActivityData>>
            >(`user-activity/getWeeklyActivity`, {
                sortBy,
                sortOrder,
                teamIds,
                ...(groupId != null ? { groupId } : {})
            });
            toggleLoading("fetchWeeklyActiveData", false);

            if (isValid) {
                setWeeklyActiveUserRecords(result);
            }

            callback && callback(isValid, RESPONSE_CODES[message]);
            return result;
        } catch (error: any) {
            toggleLoading("fetchWeeklyActiveData", false);
            setWeeklyActiveUserRecords([]);

            if (error.response) {
                const ERROR_CODE = (
                    error as AxiosError<DefaultRes>
                ).response?.data?.message;

                callback && callback(false, RESPONSE_CODES[ERROR_CODE!] || RESPONSE_CODES.UNKNOWN);
                return;
            }
            callback && callback(false, String(error));
        }
    }

    public static async fetchTeamUsersActivity(
        teamId : string | string[],
        filter: UserActivityTypes.UserActivityFilter,
        sortBy: string,
        sortOrder: 'ASC' | 'DESC',
        callback?: (isValid?: boolean, message?: string) => void
    ): Promise<any | void> {
        const {
            dispatch: { toggleLoading, setTeamUserRecords },
        } = UserActivityService;

        toggleLoading("fetchTeamUserActivityRecords", true);
        const { teamIds, startDate, endDate } = filter;
        try {
            const {
                data: { result, isValid, message },
            } = await api.post<
                DefaultRes<UserActivityTypes.TeamUserActivityData>,
                AxiosResponse<DefaultRes<UserActivityTypes.TeamUserActivityData>>
            >(`user-activity/getTeamUsersActivity`, {
                teamId,
                startDate,
                endDate,
                sortBy,
                sortOrder
            });
            toggleLoading("fetchTeamUserActivityRecords", false);

            if (isValid) {
                setTeamUserRecords(result);
            }

            callback && callback(isValid, RESPONSE_CODES[message]);
            return result;
        } catch (error: any) {
            toggleLoading("fetchTeamUserActivityRecords", false);
            setTeamUserRecords([]);

            if (error.response) {
                const ERROR_CODE = (
                    error as AxiosError<DefaultRes>
                ).response?.data?.message;

                callback && callback(false, RESPONSE_CODES[ERROR_CODE!] || RESPONSE_CODES.UNKNOWN);
                return;
            }
            callback && callback(false, String(error));
        }
    }

    public static async fetchTeamUsersWeeklyActivity(
        teamId : string | string[],
        filter: UserActivityTypes.UserActivityFilter,
        sortBy: string,
        sortOrder: 'ASC' | 'DESC',
        callback?: (isValid?: boolean, message?: string) => void
    ): Promise<any | void> {
        const {
            dispatch: { toggleLoading, setWeeklyTeamUserRecords},
        } = UserActivityService;

        toggleLoading("fetchTeamUserWeeklyActivityRecords", true);
        const { teamIds } = filter;
        try {
            const {
                data: { result, isValid, message },
            } = await api.post<
                DefaultRes<UserActivityTypes.TeamUserActivityData>,
                AxiosResponse<DefaultRes<UserActivityTypes.TeamUserActivityData>>
            >(`user-activity/getTeamUsersWeeklyActivity`, {
                teamId,
                sortBy,
                sortOrder
            });
            toggleLoading("fetchTeamUserWeeklyActivityRecords", false);

            if (isValid) {
                setWeeklyTeamUserRecords(result);
            }

            callback && callback(isValid, RESPONSE_CODES[message]);
            return result;
        } catch (error: any) {
            toggleLoading("fetchTeamUserWeeklyActivityRecords", false);
            setWeeklyTeamUserRecords([]);

            if (error.response) {
                const ERROR_CODE = (
                    error as AxiosError<DefaultRes>
                ).response?.data?.message;

                callback && callback(false, RESPONSE_CODES[ERROR_CODE!] || RESPONSE_CODES.UNKNOWN);
                return;
            }
            callback && callback(false, String(error));
        }
    }

}
